export const Actions = {
    'USER_LOGIN_LOADING': 'USER_LOGIN_LOADING',
    'USER_LOGIN_SUCCESS': 'USER_LOGIN_SUCCESS',
    'USER_LOGIN_ERROR': 'USER_LOGIN_ERROR',
    'GET_ACCOUNT_CONFIG': 'GET_ACCOUNT_CONFIG'
};